import { type MutationResolvers } from '../../../../generated/graphql'
import { type ApolloResolverContext } from '@edge/spark/io-apollo'
import { setIsEditingLayouts } from '../../../../Stores'

export const beginEditingLayoutsResolver: MutationResolvers<ApolloResolverContext>['beginEditingLayouts'] = () => {
    console.debug('io-dashboards beginEditingLayoutsResolver deprecated, use setIsEditingLayouts')
    setIsEditingLayouts(true)
    return true
}
